import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../api/baseURL';


// *** FORCED BASE URL AS YOU ASKED ***

const VehiclePage = () => {
  const [logs, setLogs] = useState([]);
  const [vehicle, setVehicle] = useState(null);
  const [search, setSearch] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage] = useState(5);

  const fetchVehicle = async () => {
    const vehicleId = localStorage.getItem('vehicleId');
    const token = localStorage.getItem('authToken');
    if (!vehicleId) return;
    try {
      const res = await axios.get(`${API_URL}/vehicles/${vehicleId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setVehicle(res.data);
    } catch { setVehicle(null); }
  };

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const vehicleId = localStorage.getItem('vehicleId');
      const res = await axios.get(`${API_URL}/maintenance/history/${vehicleId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const confirmedLogs = res.data.filter(log => log.status !== 'pending');
      setLogs(confirmedLogs);
    } catch (err) {
      setMessage('Failed to load maintenance logs');
    }
    setLoading(false);
  };

  useEffect(() => {
    const vehicleId = localStorage.getItem('vehicleId');
    if (vehicleId) {
      fetchVehicle();
      fetchLogs();
    } else {
      setMessage('Please select a vehicle first.');
      setLoading(false);
    }
  }, []);

  useEffect(() => { setPage(1); }, [search]);

  const filtered = logs
    .filter(log => `${log.description} ${log.serviceReason}`.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  const paginated = filtered.slice((page - 1) * perPage, page * perPage);
  const totalPages = Math.ceil(filtered.length / perPage);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-semibold mb-4">Maintenance History</h2>

      {vehicle && (
        <div className="mb-4">
          <h3 className="text-lg font-bold text-blue-600">
            {vehicle.brand} {vehicle.model} ({vehicle.plateNumber})
          </h3>
          <div className="text-[#6E665C] text-xs">VIN: {vehicle.vin}</div>
        </div>
      )}

      <input
        type="text"
        placeholder="Search logs..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="w-full p-2 border rounded mb-4"
      />

      {loading && <p className="text-[#6E665C]">Loading...</p>}
      {message && <p className="text-red-600 mb-4">{message}</p>}

      {paginated.map(log => (
        <div key={log._id} className="border rounded-lg p-4 mb-4 shadow-sm">
          <h3 className="text-lg font-bold">
            {new Date(log.date).toLocaleDateString('fr-CI', { year: 'numeric', month: 'short', day: 'numeric' })} - {log.description || log.serviceReason}
          </h3>
          <p className="text-sm text-[#C9C3B6]">
            Workshop: {typeof log.workshop === 'object' ? log.workshop?.businessName || log.workshop?.name || '-' : log.workshop || '-'}
          </p>
          <p className="text-sm text-[#C9C3B6]">
            Cost: {Number(log.totalCost || 0).toLocaleString()} FCFA
          </p>
          <span className={`text-xs font-semibold rounded inline-block px-2 py-1 ${
            log.status === 'confirmed' ? 'bg-green-100 text-green-700'
              : log.status === 'rejected' ? 'bg-red-100 text-red-700'
              : 'bg-[#1B1815] text-[#C9C3B6]'
          }`}>
            Status: {log.status}
          </span>
        </div>
      ))}

      {filtered.length === 0 && !loading && (
        <p className="text-[#8F877B]">No maintenance logs found.</p>
      )}

      {totalPages > 1 && (
        <div className="flex justify-center items-center mt-4 space-x-2">
          <button onClick={() => setPage(p => Math.max(p - 1, 1))} disabled={page === 1} className="px-3 py-1 border rounded">Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button onClick={() => setPage(p => Math.min(p + 1, totalPages))} disabled={page === totalPages} className="px-3 py-1 border rounded">Next</button>
        </div>
      )}
    </div>
  );
};

export default VehiclePage;
